var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tooltip',{staticClass:"c-tooltip-link",attrs:{"message":_vm.message,"position":_vm.position}},[_c(_vm.linkType,{tag:"component",attrs:{"to":_vm.to}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }